import React from 'react';
export function Footer() {
  return <footer className="bg-slate-900 py-6 sm:py-12 border-t border-slate-800" data-id="element-175">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center" data-id="element-176">
        <h2 className="text-sm sm:text-xl font-bold text-white mb-1.5 sm:mb-2" data-id="element-177">
          🏥 MEGAPACK GUARDIA PEDIÁTRICA PRO™
        </h2>
        <p className="text-[9px] sm:text-sm text-slate-400 mb-4 sm:mb-8" data-id="element-178">
          El sistema N°1 de guardia pediátrica para el médico argentino.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-8 text-[9px] sm:text-sm text-slate-500 mb-4 sm:mb-8" data-id="element-179">
          <a href="mailto:contacto@mundodigitalarg.com" className="hover:text-white transition-colors" data-id="element-180">
            contacto@mundodigitalarg.com
          </a>
          <span className="hidden sm:inline" data-id="element-181">·</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-182">
            @mundodigitalarg
          </a>
        </div>

        <p className="text-[8px] sm:text-xs text-slate-600" data-id="element-183">
          © mundodigitalarg™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}